import { globalStyles } from 'shared/constants';
const { margin, padding, text, display, flex } = globalStyles;

const style = {
  tableHead: {
    background: "#2470AC",
  }
};

export default style;